module.exports = __webpack_public_path__ + "static/media/mascot.e3e721db.png";